module.exports = __webpack_public_path__ + "static/media/genesisWatermark.8e53b5f3.png";